import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

const root = document.getElementById('root')
if (!root) throw new Error('Root element not found')

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
)

// ── Register service worker for PWA (install + offline support) ──────────────
// Only in production builds — dev server would otherwise cache HMR artefacts.
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js', { scope: '/' })
      .catch(err => {
        // eslint-disable-next-line no-console
        console.warn('SW registration failed', err)
      })
  })
}
